import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Flickity from 'flickity';
import testimonials from './testimonials';

class Testimonial extends Component {
  render () {
    return (
      <blockquote className='featured-testimonial featured-testimonial--centered'>
        <p>{this.props.testimonial[0]}</p>
        <footer>
          <cite>{this.props.testimonial[1]}, {this.props.testimonial[2]}, {this.props.testimonial[3]}</cite>
        </footer>
      </blockquote>
    );
  }
}

class TestimonialsCarousel extends Component {
  constructor (props) {
    super(props);
    this.shuffle = this.shuffle.bind(this);
    this.shuffledTestimonials = this.shuffle(testimonials);
  }

  componentDidMount () {
    const flickityOptions = {
      autoPlay: 5000,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: false,
      setGallerySize: true,
      wrapAround: true,
      cellAlign: 'left'
    };
    this.flkty = new Flickity(this.testimonialCarousel, flickityOptions);
  }

  // https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
  shuffle (array) {
    let currentIndex = array.length;
    let temporaryValue = null;
    let randomIndex = null;
    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  // <div className='testimonial-carousel js-carousel' data-flickity='{ autoPlay: 400, prevNextButtons: false, pageDots: false, adaptiveHeight: false, setGallerySize: true, wrapAround: true }'>
  // <div ref={(input) => { this.carousel = input; }} className='testimonial-carousel js-carousel'>

  render () {
    return (
      <section className='bottom-cta highlighted-section'>
        <div className='l-container l-container--narrow'>
          <h2 className='split-heading split-heading--brand kilo'>Ready to learn BSL? <strong>Join 900+ happy students now!</strong></h2>
          <div ref={(input) => { this.testimonialCarousel = input; }} className='testimonial-carousel js-carousel' style={{height: 300}}>
            {
              this.shuffledTestimonials.map((t) => (
                <Testimonial testimonial={t} key={t[1]} />
              ))
            }
          </div>
          <Link to={'/get-started'} className='button button--l button--shadow'>Start learning for free now</Link>
          <p className='cta-info'>We'll help you pick the right course in the next step.</p>
        </div>
      </section>
    );
  }
}

export default TestimonialsCarousel;



// WEBPACK FOOTER //
// ./src/components/TestimonialsCarousel/index.js